import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9c6ddaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-flex" }
const _hoisted_2 = { class: "request-outer" }
const _hoisted_3 = { class: "request-inner" }
const _hoisted_4 = { class: "request-outer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request-inner" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Coming Soon")
], -1))
const _hoisted_6 = { class: "request-outer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request-inner" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Coming Soon")
], -1))
const _hoisted_8 = { class: "request-outer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request-inner" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Coming Soon")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_TopButton = _resolveComponent("TopButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { title: '費用申請' }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TopButton, {
          class: "requset-button",
          buttonItem: _ctx.NewTransportCost
        }, null, 8, ["buttonItem"]),
        _createVNode(_component_TopButton, {
          class: "requset-button",
          buttonItem: _ctx.TransportCostApproveList
        }, null, 8, ["buttonItem"]),
        _createVNode(_component_TopButton, {
          class: "requset-button",
          buttonItem: _ctx.TransportCostList
        }, null, 8, ["buttonItem"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Title, { title: '備品申請' }),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Title, { title: '社員追加申請' }),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Title, { title: '退職者申請' }),
      _hoisted_9
    ])
  ]))
}